// import Vue from 'vue';
// import install from './install';
import service from './ngt-request';

/** deprecated in Vue 3*/
// Vue.use(install);

export default service;
